<ng-container>
    <!-- Model driven field -->
    <ng-container *ngIf="parentForm && name && control">
        <div class="forms-input{{inputSize && inputSize !== 'none' ? ' -input-size-'+inputSize : ''}} -status-{{(errors ? 'invalid' : control.status) | lowercase}}"
            [formGroup]="parentForm"
            *ngLet="{'-input-center': inputCenter,'-compact': compact,'is-optional': !required,'is-required': required,'is-dirty': control?.pristine === false,'is-pristine': control?.pristine, 'is-untouched': !control?.touched, 'is-touched': control?.touched, 'is-enabled': control?.status !== 'DISABLED', 'is-disabled': control?.status === 'DISABLED', 'is-valid': !control?.errors && control?.touched && !errors, 'is-invalid': hasErrors, 'has-value': hasValue, 'is-empty': !hasValue, '-no-resize': !resize, '-resize': resize, 'is-focusing': isFocusing, '-readonly': readonly === true, '-show-hint': showHint } as modelClasses"
            [ngClass]="modelClasses">
            <div class="forms-input__inner">

                <label [for]="name" class="forms-input__label"
                    *ngIf="label && type !== 'checkbox' && type !== 'radio'">{{label}}{{!required ? optionalLabel : ''}}</label>
                <div class="forms-input__bd">

                    <shared-hint-with-indicator *ngIf="showHintsComponent" [hintsSize]="hintsSize"
                        [hintsFeel]="hintsFeel" [hintsVSide]="hintsVSide" [hintsHSide]="hintsHSide"
                        [messages]="control.errors || errors" [indicatorType]="indicatorStatus"
                        (onButtonClick)="handleButtonClick($event)" class="forms-input__status-indicator">
                    </shared-hint-with-indicator>

                    <shared-circle-btn [disabled]="disabled" *ngIf="!disabled && enableClear && control.value"
                        class="forms-input__clear" size="xxs" icon="close" feel="dark"
                        (click)="handleClearInputValue($event)">
                    </shared-circle-btn>

                    <ng-container [ngSwitch]="type">
                        <ng-template #forCheckType>
                            <label class="forms-input__check-label" [ngClass]="{'-compact': compact}">
                                <shared-forms-check-indicator [checked]="control.value" [icon]="icon">
                                </shared-forms-check-indicator>

                                <input [attr.formnovalidate]="novalidate" [attr.readonly]="readonly"
                                    [tabindex]="tabindex" [formControlName]="name" type="checkbox"
                                    *ngIf="type === 'checkbox'" [ngClass]="modelClasses" (focus)="handleOnFocus($event)"
                                    (blur)="handleOnBlur($event)" (click)="handleOnClick($event)"
                                    class="forms-input__input{{ type ? ' -type-'+type : ''}} -type-check -status-{{(errors ? 'invalid' : control.status) | lowercase}} -for-check{{icon ? ' -custom-icon': ''}}{{icon ? ' -hidden': ''}}">

                                <input [attr.formnovalidate]="novalidate" [attr.readonly]="readonly"
                                    [tabindex]="tabindex" [formControlName]="name" *ngIf="type === 'radio'" type="radio"
                                    [ngClass]="modelClasses" (focus)="handleOnFocus($event)"
                                    (blur)="handleOnBlur($event)" (click)="handleOnClick($event)"
                                    class="forms-input__input{{ type ? ' -type-'+type : ''}} -type-check -status-{{(errors ? 'invalid' : control.status) | lowercase}} -for-check{{icon ? ' -custom-icon': ''}}{{icon ? ' -hidden': ''}}">


                                <div class="forms-input__sub-label">{{label}}</div>
                            </label>
                        </ng-template>

                        <ng-container *ngSwitchCase="'checkbox'">
                            <ng-container *ngTemplateOutlet="forCheckType"></ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'radio'">
                            <ng-container *ngTemplateOutlet="forCheckType"></ng-container>
                        </ng-container>


                        <ng-container *ngSwitchCase="'textarea'">
                            <textarea directive-numbers-only [numbersOnlyDisabled]="!numbersOnly" directive-emoji-block
                                [attr.autocomplete]="autocomplete" [attr.formnovalidate]="novalidate" [attr.min]="min"
                                [attr.minLength]="minLength" [attr.max]="max" [attr.maxLength]="maxLength"
                                [attr.pattern]="pattern" [attr.inputmode]="inputmode" [tabindex]="tabindex"
                                [formControlName]="name" [name]="name" [ngClass]="modelClasses"
                                [attr.readonly]="readonly" [placeholder]="placeholder" (focus)="handleOnFocus($event)"
                                (blur)="handleOnBlur($event)" (click)="handleOnClick($event)"
                                class="forms-input__input{{ type ? ' -type-'+type : ''}} -status-{{(errors ? 'invalid' : control.status) | lowercase}} -for-type"></textarea>
                        </ng-container>


                        <ng-container *ngSwitchCase="'datePicker'">
                            <input directive-numbers-only [numbersOnlyDisabled]="!numbersOnly" directive-emoji-block
                                directive-input-cp directive-input-regexp
                                [attr.autocomplete]="autocomplete ? 'true' : 'false'" [attr.formnovalidate]="novalidate"
                                [attr.minLength]="minLength" [attr.maxLength]="maxLength" [attr.pattern]="pattern"
                                [attr.inputmode]="inputmode" [tabindex]="tabindex" [regexp]="pattern" [min]="minDate"
                                [max]="maxDate" matInput [matDatepicker]="datePicker" [formControlName]="name"
                                type="text" [name]="name" [ngClass]="modelClasses" [placeholder]="placeholder"
                                (focus)="handleOnFocus($event)" (click)="handleOnClick($event)"
                                (blur)="handleOnBlur($event)" (dateInput)="handleDateChange($event)"
                                (dateChange)="handleDateChange($event)" [attr.readonly]="true"
                                class="forms-input__input -type-datepicker -type-common -status-{{(errors ? 'invalid' : control.status) | lowercase}} -for-type">

                            <mat-datepicker-toggle matSuffix [for]="datePicker" class="forms-input__date-picker-toggle">
                                <mat-icon matDatepickerToggleIcon class="forms-input__date-picker-icon">
                                    today
                                </mat-icon>
                            </mat-datepicker-toggle>

                            <mat-datepicker [touchUi]="isSmallScreen" #datePicker [startAt]="startDate"
                                class="forms-input__date-picker" [disabled]="control?.status === 'DISABLED'">
                            </mat-datepicker>

                        </ng-container>



                        <ng-container *ngSwitchCase="'select'">
                            <div class="forms-input__select-group">

                                <select class="forms-input__input{{ type ? ' -type-'+type : ''}} -for-type -hidden"
                                    [attr.autocomplete]="autocomplete" [attr.formnovalidate]="novalidate"
                                    [tabindex]="tabindex" [formControlName]="name" [name]="name"
                                    [attr.readonly]="readonly" [ngClass]="modelClasses">
                                    <option *ngFor="let option of selectOptions" [value]="option.Id">{{option.Id}}
                                    </option>
                                </select>


                                <shared-drop-down class="forms-input__dropdown" (onToggle)="onSelectToggle($event)"
                                    (onSelected)="onSelected($event)" [options]="selectOptions" [selected]="selected"
                                    [position]="position" [theme]="theme" [width]="selectWidth"
                                    [projection]="projection" [size]="selectDropdownSize"
                                    [optionTemplate]="optionTemplate">

                                    <button type="button" [disabled]="control?.disabled || disabled" #selectButton
                                        class="forms-input__input{{ type ? ' -type-'+type : ''}} -for-type -select-as-input"
                                        [tabindex]="tabindex || -1" [attr.data-placeholder]="placeholder"
                                        [ngClass]="{'-with-placeholder': placeholder && !selected, 'is-disabled': control?.disabled || disabled, 'has-value': control?.value}">
                                        <ng-container *ngIf="selected">

                                            <ng-container
                                                *ngTemplateOutlet="selectedTemplate || null;context: {item: selected}">
                                            </ng-container>
                                        </ng-container>

                                        <ng-container *ngIf="!selectedTemplate">{{selected && selected.Name}}
                                        </ng-container>


                                        <shared-icon-btn class="forms-input__select-icon"
                                            [disabled]="control?.disabled || disabled" [hoverShadow]="false"
                                            [icon]="selectIsOpen ? 'up' : 'down'" [size]="selectIconSize">
                                        </shared-icon-btn>

                                    </button>
                                </shared-drop-down>


                            </div>
                        </ng-container>



                        <ng-container *ngSwitchDefault>
                            <input directive-numbers-only [numbersOnlyDisabled]="!numbersOnly" directive-emoji-block
                                [attr.readonly]="readonly" [attr.autocomplete]="autocomplete"
                                [attr.formnovalidate]="novalidate" [attr.min]="min" [attr.minLength]="minLength"
                                [attr.max]="max" [attr.maxLength]="maxLength" [attr.pattern]="pattern"
                                [attr.inputmode]="inputmode" [tabindex]="tabindex" [formControlName]="name"
                                [type]="type" [name]="name" [ngClass]="modelClasses" [placeholder]="placeholder"
                                (focus)="handleOnFocus($event)" (blur)="handleOnBlur($event)"
                                (click)="handleOnClick($event)"
                                class="forms-input__input{{ type ? ' -type-'+type : ''}} -type-common -status-{{(errors ? 'invalid' : control.status) | lowercase}} -for-type">
                        </ng-container>

                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>


    <!-- Template driven field -->
    <ng-container *ngIf="!parentForm || parentForm && !name">
        <div class="forms-input"
            *ngLet="{'-compact': compact, 'is-required': required, 'has-value': value || selected, 'is-empty': !value && !selected,'-no-resize': !resize, '-resize': resize,'is-valid': valid, 'is-invalid': hasErrors, 'is-touched': isTouched, 'is-focusing': isFocusing, 'is-disabled': disabled} as templateDrivenClasses"
            [ngClass]="templateDrivenClasses">
            <div class="forms-input__inner">
                <label [for]="name" class="forms-input__label"
                    *ngIf="label && type !== 'checkbox' && type !== 'radio'">{{label}}</label>

                <div class="forms-input__bd">
                    <ng-container [ngSwitch]="type">

                        <ng-container *ngSwitchCase="'textarea'">
                            <textarea directive-numbers-only [numbersOnlyDisabled]="!numbersOnly" directive-emoji-block
                                [attr.readonly]="readonly" [attr.autocomplete]="autocomplete"
                                [attr.formnovalidate]="novalidate" [attr.min]="min" [attr.minLength]="minLength"
                                [attr.max]="max" [attr.maxLength]="maxLength" [required]="required"
                                [attr.pattern]="pattern" [attr.inputmode]="inputmode" [tabindex]="tabindex"
                                [name]="name" [disabled]="disabled" [ngClass]="templateDrivenClasses"
                                [placeholder]="placeholder" (focus)="handleOnFocus($event)"
                                (blur)="handleOnBlur($event)" [(ngModel)]="value"
                                (ngModelChange)="handleValueChange($event)" (click)="handleOnClick($event)"
                                class="forms-input__input{{ type ? ' -type-'+type : ''}} -for-type"></textarea>
                        </ng-container>

                        <ng-container *ngSwitchCase="'select'">
                            <div class="forms-input__select-group">

                                <select class="forms-input__input{{ type ? ' -type-'+type : ''}} -for-type -hidden"
                                    [attr.formnovalidate]="novalidate" [tabindex]="tabindex" [(ngModel)]="value"
                                    [attr.readonly]="readonly" [name]="name" [ngClass]="modelClasses">
                                </select>


                                <shared-drop-down class="forms-input__dropdown" (onToggle)="onSelectToggle($event)"
                                    (onSelected)="onSelected($event)" [options]="selectOptions" [selected]="selected"
                                    [position]="position" [theme]="theme" [width]="selectWidth"
                                    [projection]="projection" [size]="selectDropdownSize"
                                    [optionTemplate]="optionTemplate">

                                    <button type="button" [disabled]="disabled"
                                        class="forms-input__input{{ type ? ' -type-'+type : ''}} -for-type -select-as-input"
                                        [attr.data-placeholder]="placeholder"
                                        [ngClass]="{'-with-placeholder': placeholder && !selected, 'is-disabled': disabled, 'has-value': selected}"
                                        #selectButton>

                                        <ng-container *ngIf="selected">
                                            <ng-container
                                                *ngTemplateOutlet="selectedTemplate || null;context: {item: selected}">
                                            </ng-container>
                                        </ng-container>

                                        <ng-container *ngIf="!selectedTemplate">{{selected && selected.Name}}
                                        </ng-container>


                                        <shared-icon-btn class="forms-input__select-icon" [disabled]="disabled"
                                            [hoverShadow]="false" [icon]="selectIsOpen ? 'up' : 'down'"
                                            [size]="selectIconSize">
                                        </shared-icon-btn>

                                    </button>
                                </shared-drop-down>


                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'datePicker'">
                            <input directive-numbers-only [numbersOnlyDisabled]="!numbersOnly" directive-emoji-block
                                directive-input-cp directive-input-regexp [attr.autocomplete]="autocomplete"
                                [attr.formnovalidate]="novalidate" [attr.min]="min" [attr.minLength]="minLength"
                                [attr.max]="max" [attr.maxLength]="maxLength" [attr.pattern]="pattern"
                                [attr.inputmode]="inputmode" [tabindex]="tabindex" [regexp]="pattern" [min]="minDate"
                                [max]="maxDate" matInput [matDatepicker]="datePicker" [(ngModel)]="value" type="text"
                                [name]="name" [ngClass]="modelClasses" [placeholder]="placeholder"
                                (focus)="handleOnFocus($event)" (blur)="handleOnBlur($event)"
                                (dateChange)="handleDateChange($event)" (ngModelChange)="handleValueChange($event)"
                                [attr.readonly]="true" (click)="handleOnClick($event)"
                                class="forms-input__input -type-datepicker -type-common -status-{{(errors ? 'invalid' : control.status) | lowercase}} -for-type">

                            <mat-datepicker-toggle matSuffix [for]="datePicker" class="forms-input__date-picker-toggle">
                                <mat-icon matDatepickerToggleIcon class="forms-input__date-picker-icon">
                                    today
                                </mat-icon>
                            </mat-datepicker-toggle>

                            <mat-datepicker [touchUi]="isSmallScreen" #datePicker [startAt]="startDate"
                                class="forms-input__date-picker" [disabled]="control?.status === 'DISABLED'">
                            </mat-datepicker>

                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            <input directive-numbers-only [numbersOnlyDisabled]="!numbersOnly" directive-emoji-block
                                [attr.readonly]="readonly" [attr.autocomplete]="autocomplete"
                                [attr.formnovalidate]="novalidate" [attr.min]="min" [attr.minLength]="minLength"
                                [attr.max]="max" [attr.maxLength]="maxLength" [required]="required"
                                [attr.pattern]="pattern" [attr.inputmode]="inputmode" [tabindex]="tabindex"
                                [type]="type" [name]="name" [disabled]="disabled" [ngClass]="templateDrivenClasses"
                                [placeholder]="placeholder" (focus)="handleOnFocus($event)"
                                (blur)="handleOnBlur($event)" [(ngModel)]="value"
                                (ngModelChange)="handleValueChange($event)" (click)="handleOnClick($event)"
                                class="forms-input__input{{ type ? ' -type-'+type : ''}} -type-common -for-type">
                        </ng-container>

                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>